import { type INewbuildingsPlusBlocksPikContractSchema } from 'shared/repositories/special-promos/entities/newbuildings_plus_blocks_pik_contract/NewbuildingsPlusBlocksPikContractSchema';
import { type IApplicationState } from 'shared/types/redux';

/**
 * Обновляет состояние - добавляет данные о ПИК+ для ЖК
 */
export function mergePikPlusDataToInitialState(
  initialState: IApplicationState,
  response: INewbuildingsPlusBlocksPikContractSchema[],
): void {
  response.forEach(item => {
    const residential = initialState.residentialComplexes.hash[item.newbuildingId];
    if (residential) {
      residential.displayType = 'plus';
      residential.description = item.description;
      residential.equipmentOptions = (item.equipmentOptions ?? []).map(equipment => {
        return {
          imageUrl: equipment.image,
          title: equipment.title,
        };
      });
    }
  });
}
